import { LinkButton } from '@stories/Components/Buttons/Button/Button';
import { Background, ContentType } from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import { debounce } from 'lodash';
import * as React from 'react';
import S from './InnerPageHero.styles';
const InnerPageHero = (props) => {
    const contentRef = React.useRef(null);
    const [readAll, setReadAll] = React.useState(false);
    const [showReadMore, setShowReadMore] = React.useState(false);
    const onResize = React.useCallback(debounce(checkReadMore, 100), []);
    React.useEffect(() => {
        onResize();
        window.addEventListener('resize', onResize);
        return () => {
            window.removeEventListener('resize', onResize);
        };
    }, []);
    return (React.createElement(S.Container, { background: props.type === ContentType.Intermediaries
            ? Background.Beige
            : props.type === ContentType.Savings
                ? Background.Blue
                : Background.Green, translations: props.translations, "data-read-all": readAll },
        props.subtitle && React.createElement(S.Subtitle, null, props.subtitle),
        React.createElement(S.Title, null, props.title),
        props.introduction && (React.createElement(S.Introduction, null,
            React.createElement("p", { ref: contentRef }, props.introduction),
            React.createElement(S.ReadMore, { onClick: () => setReadAll(true), "data-active": showReadMore && !readAll }, props.translations?.['global.readMore.open']))),
        props.ctas && props.ctas.length > 0 && (React.createElement(S.CtaWrapper, null, props.ctas.map((cta, index) => (React.createElement(LinkButton, { key: `iph-${index}`, buttonType: props.type === ContentType.Intermediaries
                ? 'intermediaries'
                : props.type === ContentType.Savings
                    ? 'savings'
                    : 'default', href: cta.url, target: cta.target, icon: cta.icon }, cta.text)))))));
    function checkReadMore() {
        if (!contentRef.current) {
            return;
        }
        if (contentRef.current.scrollHeight > contentRef.current.clientHeight) {
            return setShowReadMore(true);
        }
        return setShowReadMore(false);
    }
};
export default InnerPageHero;
